<template>
  <span class="chip" :class="`chip-${variant}`">{{ label }}</span>
</template>

<script>
const STATUS_INSCRICAO = {
  PENDENTE: { label: 'Pendente', variant: 'warning' },
  PARCIAL: { label: 'Parcial', variant: 'info' },
  QUITADA: { label: 'Quitada', variant: 'success' },
  ATRASADA: { label: 'Atrasada', variant: 'danger' },
  CANCELADA: { label: 'Cancelada', variant: 'muted' }
}
const STATUS_EVENTO = {
  RASCUNHO: { label: 'Rascunho', variant: 'muted' },
  ABERTO: { label: 'Aberto', variant: 'success' },
  ENCERRADO: { label: 'Encerrado', variant: 'warning' },
  ARQUIVADO: { label: 'Arquivado', variant: 'muted' }
}

export default {
  name: 'StatusChip',
  props: {
    status: { type: String, required: true },
    kind: { type: String, default: 'inscricao' }
  },
  computed: {
    config() {
      const map = this.kind === 'evento' ? STATUS_EVENTO : STATUS_INSCRICAO
      return map[this.status] || { label: this.status, variant: 'muted' }
    },
    label() { return this.config.label },
    variant() { return this.config.variant }
  }
}
</script>

<style scoped>
.chip {
  display: inline-block;
  font-size: 11px; font-weight: 700; letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 3px 8px; border-radius: 4px;
}
.chip-success { background: #dcfce7; color: #166534; }
.chip-info { background: #dbeafe; color: #1d4ed8; }
.chip-warning { background: #fef3c7; color: #92400e; }
.chip-danger { background: #fee2e2; color: #b91c1c; }
.chip-muted { background: #f3f4f6; color: #4b5563; }
</style>
